export const PLAIN = 'plain';
export const KEY_DATA = 'key_data';
export const TRANSITION = 'transition';
export const QUOTATION = 'quotation';

const stripeTypes = [PLAIN, KEY_DATA, TRANSITION, QUOTATION];

export default stripeTypes;
